import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {amCharts_v4_category_line_template} from "./amCharts_v4_category_line_template";
import {amCharts_v4_category_basic_template} from "./amCharts_v4_category_basic_template";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";

declare var ko: any;

export class featurePoints_template extends vnTemplate {

    public filterYears: multipleSelector_template;
    public filterProjects: multipleSelector_template;
    public filterDepartments: multipleSelector_template;
    public filterAssignees: multipleSelector_template;
    public presetFilter: presetFilter_template;
    public validationsList: validationsList_template;
    public quarterlyGraph: amCharts_v4_category_line_template;
    public dashboardGraph: amCharts_v4_category_basic_template;
    protected pagination: pagination_template;
    protected csvExporter: exportDataCsv;

    readonly viewModes = [
        {"id": "quarterly", "name": "Quarterly"},
        //{"id": "granular", "name": "Granular"},
        {"id": "dashboard", "name": "Dashboard"},
    ];

    readonly singleFilterQuarters = [
        {"id": "q1", "name": "Q1"},
        {"id": "q2", "name": "Q2"},
        {"id": "q3", "name": "Q3"},
        {"id": "q4", "name": "Q4"},
    ];

    protected getTemplateHtml(): string {

        return `
            <div class="sub-header w-justify">
                <div class="list-header w-justify">
                    <div class="w-left">
                        <div class="dropdown select-single">
                            <label class="form-label" for="">View Mode</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: viewModeSelected"></button>
                            
                            <div class="dropdown-list"> 
                                <div class="w-form">   
                                    <div class="form-group" data-bind="foreach: viewModes">
                                        <input type="radio" data-bind="checked : $parent.viewModeSelected, value: id,  attr: { 'id': 'view_' + id, 'name' : 'view_' + id }, event:{ change: $parent.onViewModeChange}">
                                        <label class="form-label" data-bind="attr: {for : 'view_' + id }, text: name"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- ko if: viewModeSelected() == 'quarterly' -->
                            ${this.filterYears.getHtmlBuild()}
                        <!-- /ko -->
                        <!-- ko if: viewModeSelected() == 'dashboard' -->
                            <div class="dropdown select-single">
                                <label class="form-label" for="">Years</label>
                                <button class="dropdown-toggle" type="button" data-bind="text: singleYearSelected"></button>
                                
                                <div class="dropdown-list"> 
                                    <div class="w-form">   
                                        <div class="form-group" data-bind="foreach: singleFilterYears">
                                            <input type="radio" data-bind="checked : $parent.singleYearSelected, value: id,  attr: { 'id': 'view_' + id, 'name' : 'view_' + id }, event:{ change: $parent.onSingleYearChange}">
                                            <label class="form-label" data-bind="attr: {for : 'view_' + id }, text: name"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="dropdown select-single">
                                <label class="form-label" for="">Quarters</label>
                                <button class="dropdown-toggle" type="button" data-bind="text: singleQuarterSelected"></button>
                                
                                <div class="dropdown-list"> 
                                    <div class="w-form">   
                                        <div class="form-group" data-bind="foreach: singleFilterQuarters">
                                            <input type="radio" data-bind="checked : $parent.singleQuarterSelected, value: id,  attr: { 'id': 'view_' + id, 'name' : 'view_' + id }, event:{ change: $parent.onSingleQuarterChange}">
                                            <label class="form-label" data-bind="attr: {for : 'view_' + id }, text: name"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <!-- /ko -->
                        
                        ${this.filterDepartments.getHtmlBuild()}
                        ${this.filterAssignees.getHtmlBuild()}
                    </div>
                    <div class="w-right" style="flex:none;">
                        <button data-bind="click: onClickConfig" class="btn secondary icon i-settings" type="button">Configuration</button>
                    </div>  
                </div>
            </div>
                        
             <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div data-bind="visible: viewModeSelected()=='quarterly'" id="selected-years"></div>
                    <div id="selected-projects"></div>
                    <div id="selected-departments"></div>
                    <div id="selected-assignees"></div>
                </div>   
            </div>
            
            <div class="list-header w-justify">
            
                <div class="w-left">
                    <h2 class="section-title">Feature Points Report</h2>
                </div>
                
                 <div class="w-right">
                    <button class="btn icon highlight i-refresh" type="button" data-bind="event: { click: updateReport}, visible: !isChartLoading()">Update</button>
                </div>
                
            </div>

            <section class="w-graph" ">
                <!-- ko if: viewModeSelected()=='quarterly' -->
                    <div style="width: 100%" data-bind="visible: !isChartLoading()">
                        ${this.quarterlyGraph.getHtmlBuild()}
                    </div>
                <!-- /ko -->
                <!-- ko if: viewModeSelected()=='dashboard' -->
                    <div style="width: 100%" data-bind="visible: !isChartLoading()">
                        ${this.dashboardGraph.getHtmlBuild()}
                    </div>
                <!-- /ko -->
            </section>
            
            <div class="list-header w-justify" style="margin-top: 2rem">
                <div class="w-left">
                </div>
                <div class="w-right">
                    <!-- ko if: viewModeSelected() == 'dashboard' && !exportButtonHidden() -->
                    ` + this.pagination.getHtmlBuild() + `
                    <button class="btn icon highlight i-export" type="button" data-bind="event: { click: exportData}, css: { 'is-hidden': exportButtonHidden }">Export</button>
                    <!-- /ko -->
                </div>
            </div>

            <div class="w-list-results" id="list-results" style="position: relative">
                <!-- ko if: viewModeSelected() == 'dashboard' -->
                    <table class="list-results list-sections thin" data-bind="visible: !isChartLoading()">
                        <thead>
                            <tr>
                                <th><span class="icon list-sort-none i-dropdown-simple" data-bind="event: { click: onClickReorder.bind($data, 'keyIssue') }, css: { 'list-sort-desc': orderByAndDirection()=='keyIssue_DESC', 'list-sort-asc': orderByAndDirection()=='keyIssue_ASC' }">Task Identifier</span></th>
                                <th><span class="icon list-sort-none i-dropdown-simple" data-bind="event: { click: onClickReorder.bind($data, 'title') }, css: { 'list-sort-desc': orderByAndDirection()=='title_DESC', 'list-sort-asc': orderByAndDirection()=='title_ASC' }">Task Name</span></th>
                                <th><span class="icon list-sort-none i-dropdown-simple" data-bind="event: { click: onClickReorder.bind($data, 'assignee') }, css: { 'list-sort-desc': orderByAndDirection()=='assignee_DESC', 'list-sort-asc': orderByAndDirection()=='assignee_ASC' }">Assignee</span></th>
                                <th><span class="icon list-sort-none i-dropdown-simple" data-bind="event: { click: onClickReorder.bind($data, 'reporter') }, css: { 'list-sort-desc': orderByAndDirection()=='reporter_DESC', 'list-sort-asc': orderByAndDirection()=='reporter_ASC' }">Reporter</span></th>
                                <th><span class="icon list-sort-none i-dropdown-simple" data-bind="event: { click: onClickReorder.bind($data, 'qa') }, css: { 'list-sort-desc': orderByAndDirection()=='qa_DESC', 'list-sort-asc': orderByAndDirection()=='qa_ASC' }">QA</span></th>
                                <th><span class="icon list-sort-none i-dropdown-simple" data-bind="event: { click: onClickReorder.bind($data, 'featurePoints') }, css: { 'list-sort-desc': orderByAndDirection()=='featurePoints_DESC', 'list-sort-asc': orderByAndDirection()=='featurePoints_ASC' }">Feature Points</span></th>
                                <th><span class="icon list-sort-none i-dropdown-simple" data-bind="event: { click: onClickReorder.bind($data, 'qaBugCount') }, css: { 'list-sort-desc': orderByAndDirection()=='qaBugCount_DESC', 'list-sort-asc': orderByAndDirection()=='qaBugCount_ASC' }">QA Bug Count</span></th>
                                <th><span class="icon list-sort-none i-dropdown-simple" data-bind="event: { click: onClickReorder.bind($data, 'qaLiveBugCount') }, css: { 'list-sort-desc': orderByAndDirection()=='qaLiveBugCount_DESC', 'list-sort-asc': orderByAndDirection()=='qaLiveBugCount_ASC' }">Live Bug Count</span></th>
                                <th><span class="icon list-sort-none i-dropdown-simple" data-bind="event: { click: onClickReorder.bind($data, 'dueDate') }, css: { 'list-sort-desc': orderByAndDirection()=='dueDate_DESC', 'list-sort-asc': orderByAndDirection()=='dueDate_ASC' }">Delivery Date</span></th>
                                <th><span class="icon list-sort-none i-dropdown-simple" data-bind="event: { click: onClickReorder.bind($data, 'jiraStatusName') }, css: { 'list-sort-desc': orderByAndDirection()=='jiraStatusName_DESC', 'list-sort-asc': orderByAndDirection()=='jiraStatusName_ASC' }">Status</span></th>
                                <th><span class="icon list-sort-none i-dropdown-simple" data-bind="event: { click: onClickReorder.bind($data, 'lastStatusUpdateDate') }, css: { 'list-sort-desc': orderByAndDirection()=='lastStatusUpdateDate_DESC', 'list-sort-asc': orderByAndDirection()=='lastStatusUpdateDate_ASC' }">Last Status Update</span></th>
                            </tr>
                        </thead>
                        <tbody>
                        <!-- ko foreach: issuesData() -->
                            <tr>
                            <td><a class="link" data-bind="text: keyIssue, attr: { href: 'https://valnetinc.atlassian.net/browse/' + keyIssue, title: keyIssue }" target="_blank"></a></td>
                                <td><span data-bind="text: title"></span></td>
                                <td><span data-bind="text: assignee"></span></td>
                                <td><span data-bind="text: reporter"></span></td>
                                <td><span data-bind="text: qa"></span></td>
                                <td><span data-bind="text: featurePoints"></span></td>
                                <td><span data-bind="text: qaBugCount"></span></td>
                                <td><span data-bind="text: qaLiveBugCount"></span></td>
                                <td><span data-bind="text: dueDate"></sppan></td>
                                <td><span data-bind="text: jiraStatusName"></span></td>
                                <td><span data-bind="text: lastStatusUpdateDate"></span></td>
                            </tr>
                        <!-- /ko -->
                        <tbody>
                   </table>
                   <!-- /ko -->
            </div>

            `;
    }

    protected initPartial(): void {

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('featurePoints');

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 50;

        this.filterYears = new multipleSelector_template("filterYears", this.getTemplateViewModel(), this.caller);
        this.filterYears.setTagContainerId('selected-years');
        this.filterYears.setTagContainerCaption('Selected years:');

        this.filterProjects = new multipleSelector_template("filterProjects", this.getTemplateViewModel(), this.caller);
        this.filterProjects.setTagContainerId('selected-projects');
        this.filterProjects.setTagContainerCaption('Selected Projects:');

        this.filterDepartments = new multipleSelector_template("filterDepartments", this.getTemplateViewModel(), this.caller);
        this.filterDepartments.setTagContainerId('selected-departments');
        this.filterDepartments.setTagContainerCaption('Selected Departments:');

        this.filterAssignees = new multipleSelector_template("filterAssignees", this.getTemplateViewModel(), this.caller);
        this.filterAssignees.setTagContainerId('selected-assignees');
        this.filterAssignees.setTagContainerCaption('Selected Assignees:');

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);

        this.quarterlyGraph = new amCharts_v4_category_line_template("quarterlyGraph", this.getTemplateViewModel(), this.caller);
        this.dashboardGraph = new amCharts_v4_category_basic_template("dashboardGraph", this.getTemplateViewModel(), this.caller);

        this.csvExporter = new exportDataCsv();
    }

    public setDefaultSelectedFilters(){

        // By default, we want all departments to be selected, with the exception of Other and Front-End
        let ids = [];
        let selectedItems = [];
        this.filterDepartments.getItems().forEach((item) => {

            if(item.name != 'Other' && item.name != 'Front-End'){

                ids.push(item.id);
                selectedItems.push(item);
            }
        });
        this.filterDepartments.setSelectedItems(selectedItems);
        this.filterDepartments.setTags(ids, this.filterDepartments.getItems());
    }

    protected getTemplateName(): string {

        return "featurePoints_template";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        return {
            orderBy: ko.observable("jiraStatusName")
            , orderByDirection: ko.observable("ASC")
            , orderByAndDirection: ko.observable("jiraStatusName_ASC")
            , titleDate: ko.observable("")
            , headers: ko.observableArray([])
            , tableData: ko.observableArray([])
            , issuesData: ko.observableArray([])
            , viewModes: ko.observableArray([])
            , viewMethods: ko.observableArray([])
            , singleFilterYears: ko.observableArray([])
            , singleYearSelected: ko.observable()
            , singleFilterQuarters: ko.observableArray([])
            , pendingStatuses : ko.observable()
            , singleQuarterSelected: ko.observable(this.getCurrentQuarter())
            , viewModeSelected: ko.observable("quarterly")
            , viewMethodSelected: ko.observable("periods")
            , isChartLoading: ko.observable(0)
            , isVisibleComparisonDates: ko.observable(false)
            , CSVIssuesData: ko.observableArray([])
            , exportButtonHidden : ko.observable(1)
            , taskListAssigneeSelected: ko.observable("")
            , taskListStatusSelected: ko.observable("")
            , exportData : function(){ huit_neuf_this.getCsvData(huit_neuf_this); }
            , onSingleYearChange: function () { huit_neuf_this.onSingleYearChange();}
            , onSingleQuarterChange: function () { huit_neuf_this.onSingleQuarterChange();}
            , onClickConfig: function (data, event){ huit_neuf_this.onClickConfig(); }
            , onViewModeChange: function (data) { huit_neuf_this.onViewModeChange(data); }
            , updateReport: function(data){ huit_neuf_this.updateReport(); }
            , onClickReorder: function(value, data, event){ huit_neuf_this.onClickReorder(value, data, event); }
        };
    }

    public getCurrentQuarter(){

        let today = new Date();
        let mm = today.getMonth() + 1;

        if (mm >= 1 && mm <= 3){

            return 'q1';
        }else if(mm >= 4 && mm <= 6){

            return 'q2';
        }else if(mm >= 7 && mm <= 9){

            return 'q3';
        }else{

            return 'q4';
        }
    }

    public getViewModelForRequest() {
        if(this.getTemplateViewModel().viewModeSelected() == "dashboard"){
            return {
                orderBy: this.getTemplateViewModel().orderBy(),
                orderByDirection: this.getTemplateViewModel().orderByDirection(),
                viewMode: this.getTemplateViewModel().viewModeSelected(),
                year: this.getTemplateViewModel().singleYearSelected(),
                quarter: this.getTemplateViewModel().singleQuarterSelected(),
                projects: this.getTemplateViewModel().filterProjects.selectedItems(),
                departments: this.getTemplateViewModel().filterDepartments.selectedItems(),
                assignees: this.getTemplateViewModel().filterAssignees.selectedItems(),
                pagination: this.getTemplateViewModel().pagination,
                taskListAssignee: this.getTemplateViewModel().taskListAssigneeSelected(),
                taskListStatus: this.getTemplateViewModel().taskListStatusSelected(),
            }
        }
        else{
            return {
                viewMode: this.getTemplateViewModel().viewModeSelected(),
                years: this.getTemplateViewModel().filterYears.selectedItems(),
                projects: this.getTemplateViewModel().filterProjects.selectedItems(),
                departments: this.getTemplateViewModel().filterDepartments.selectedItems(),
                assignees: this.getTemplateViewModel().filterAssignees.selectedItems()
            }
        }
    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        let container = super.build(classesToAdd);

        return container;
    }

    public setViewModesItems() {
        this.getTemplateViewModel().viewModes(this.viewModes);
    }

    public setYearsFilterItems(years){

        this.filterYears.setItems(years);
        this.filterYears.setLabel('Years');

        let items = [{id: years[0].id}, {id: years[1].id}];

        this.filterYears.setSelectedItems(items);
        this.filterYears.setTags(items, this.filterYears.getItems());
    }

    public setProjectsFilterItems(projects){

        this.filterProjects.setItems(projects);
        this.filterProjects.setLabel('Projects');
    }

    public setDepartmentsFilterItems(departments){

        this.filterDepartments.setItems(departments);
        this.filterDepartments.setLabel('Departments');
    }

    public setAssigneesFilterItems(assignees){

        this.filterAssignees.setItems(assignees);
        this.filterAssignees.setLabel('Assignees');
    }

    public setPendingStatuses(pendingStatuses){

        let statuses : Map<number, String> = new Map<number, String>();
        for(let pendingStatus of pendingStatuses){

            statuses.set(pendingStatus.id, pendingStatus.name);
        }

        this.getTemplateViewModel().pendingStatuses(statuses);
    }

    public setQuartersItems() {

        this.getTemplateViewModel().singleFilterQuarters(this.singleFilterQuarters);
    }

    public setSingleYearsItems(years) {

        this.getTemplateViewModel().singleFilterYears(years);
        this.getTemplateViewModel().singleYearSelected(years[0].id);
    }

    public onClickConfig(): void {

        this.caller.config();
    }

    private onViewModeChange(selectedTemplate) {

        this.caller.getListData();
    }

    private onSingleYearChange(){

        this.caller.getListData();
    }

    private onSingleQuarterChange(){

        this.caller.getListData();
    }

    private updateReport(){

        this.caller.updateReportData();
    }

    public setHeader(data) {

        this.getTemplateViewModel().headers(data);
    }

    public setTableData(data) {

        this.getTemplateViewModel().tableData(data);
    }

    public updateQuarterlyGraphData(graphLinesInfo, data){

        this.quarterlyGraph.setCategory("category");
        let chart = this.quarterlyGraph

        chart.setDisableClickableLegend(1);
        chart.setAutoRotateLabels(1);
        chart.setLabelMaxWidth(80);
        chart.setEnableXScrollbar(0);

        let yaxis = [];

        yaxis.push({
            field: "featurePoints",
            tooltipfield: "featurePoints",
            name: "Delivered",
            axis: "main",
            color: am4core.color('#454E9E'),
            strokeWidth: 0,
            opposite: false,
            stacked: true,
            fillOpacity: 0.6,
        });

        yaxis.push({
            field: "pendingFeaturePoints",
            tooltipfield: "pendingFeaturePoints",
            name: "Pending",
            axis: "main",
            color: am4core.color('#8E95CD'),
            strokeWidth: 0,
            opposite: false,
            stacked: true,
            fillOpacity: 0.5,
        });

        yaxis.push({
            field: "objectivePoints",
            tooltipfield: "objectivePoints",
            name: "Objective",
            axis: "main",
            color: am4core.color('#55D6BE'),
            strokeWidth: 3,
            strokeDasharray: '4,2',
            opposite: false,
            filters: [new am4core.DropShadowFilter()]
        });

        chart.setYaxis(yaxis);
        chart.drawChart(data);
    }

    public setIssuesData(data){

        this.getTemplateViewModel().issuesData(data);
    }

    public updateDashboardGraphData(graphLinesInfo, data){

        this.dashboardGraph.setCategory("category");
        this.dashboardGraph.setXScrollbarEnabled(0);
        this.dashboardGraph.setLabelMaxWidth(110)
        this.dashboardGraph.setAutoRotateLabels(1);

        for (let dataChunk of data){

            this.getTemplateViewModel().pendingStatuses().forEach(function(statusName, idStatus, map){

                dataChunk['pendingPointsByJiraIdStatus' + idStatus] = 0;
            })

            for(let pointsByJiraIdStatus of dataChunk['pendingFeaturePointsByJiraIdStatus']){

                dataChunk['pendingPointsByJiraIdStatus' + pointsByJiraIdStatus.jiraIdStatus] += pointsByJiraIdStatus.featurePoints;
            }

            dataChunk['goalPoints'] = dataChunk['objectivePoints'];
            dataChunk['realPoints'] = dataChunk['pendingFeaturePoints'] + dataChunk['doneFeaturePoints'];
        }

        let chart = this.dashboardGraph.setupChart(data);

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;
        valueAxis.renderer.grid.template.disabled = true;
        valueAxis.title.text = "Value";
        valueAxis.title.fontWeight = "bold";
        valueAxis.min = 0;

        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = "objectivePoints";
        series.dataFields.categoryX = "category";
        series.name = "Objective";
        series.fill = am4core.color('#ACFCD9');
        series.strokeWidth = 0;
        series.tooltipText = "{valueY.formatNumber('#.0')} {name}";
        //series.stacked = false;
        series.clustered = false;

        let series2 = chart.series.push(new am4charts.ColumnSeries());
        series2.dataFields.valueY = "objectiveToDatePoints";
        series2.dataFields.categoryX = "category";
        series2.name = "Objective To Date";
        series2.fill = am4core.color('#55D6BE');
        series2.strokeWidth = 0;
        series2.tooltipText = "{valueY.formatNumber('#.0')} {name}";
        //series2.stacked = false;
        series2.clustered = false;

        let series3 = chart.series.push(new am4charts.ColumnSeries());
        series3.dataFields.valueY = "doneFeaturePoints";
        series3.dataFields.categoryX = "category";
        series3.name = "Done";
        series3.fill = am4core.color('#454E9E');
        series3.strokeWidth = 0;
        series3.tooltipText = "{valueY.formatNumber('#.0')} {name}";
        series3.clustered = false;
        series3.stacked = false;

        let series4 = chart.series.push(new am4charts.ColumnSeries());
        series4.dataFields.valueY = "pendingFeaturePoints";
        series4.dataFields.categoryX = "category";
        series4.name = "Pending";
        series4.fill = am4core.color('#8E95CD');
        series4.strokeWidth = 0;
        let tooltipText = "{valueY.formatNumber('#.0')} {name}\n";
        this.getTemplateViewModel().pendingStatuses().forEach(function(statusName, idStatus, map){

            tooltipText += "● {pendingPointsByJiraIdStatus" + idStatus + ".formatNumber('#.0')} " + statusName + "\n";
        });
        series4.tooltipText = tooltipText;
        series4.clustered = false;
        series4.stacked = true;

        series.columns.template.width = am4core.percent(30);
        series2.columns.template.width = am4core.percent(30);
        series3.columns.template.width = am4core.percent(30);
        series4.columns.template.width = am4core.percent(30);

        series.dataItems.template.locations.categoryX = 0.25;
        series2.dataItems.template.locations.categoryX = 0.25;
        series3.dataItems.template.locations.categoryX = 0.55;
        series4.dataItems.template.locations.categoryX = 0.55;

        let selectedState = series.columns.template.states.create("selected");
        selectedState.properties.stroke = am4core.color('rgba(220, 0, 0, 0.75)');
        selectedState.properties.strokeWidth = 2;

        let selectedState2 = series2.columns.template.states.create("selected");
        selectedState2.properties.stroke = am4core.color('rgba(220, 0, 0, 0.75)');
        selectedState2.properties.strokeWidth = 2;

        let selectedState3 = series3.columns.template.states.create("selected");
        selectedState3.properties.stroke = am4core.color('rgba(220, 0, 0, 0.75)');
        selectedState3.properties.strokeWidth = 2;

        let selectedState4 = series4.columns.template.states.create("selected");
        selectedState4.properties.stroke = am4core.color('rgba(220, 0, 0, 0.75)');
        selectedState4.properties.strokeWidth = 2;

        // To prevent top labels from being masked by the edge of the plot area
        chart.maskBullets = false;

        var totalGoalBullet = series.bullets.push(new am4charts.LabelBullet());
        totalGoalBullet.dy = -12;
        totalGoalBullet.label.text = "{goalPoints}";
        totalGoalBullet.label.hideOversized = false;
        totalGoalBullet.label.fontSize = 10;
        totalGoalBullet.label.background.fill = series.fill;
        totalGoalBullet.label.background.fillOpacity = 0.5;
        totalGoalBullet.label.padding(2, 2, 2, 2);
        totalGoalBullet.label.truncate = false;
        totalGoalBullet.maxWidth = 50;

        var totalRealBullet = series4.bullets.push(new am4charts.LabelBullet());
        totalRealBullet.dy = -12;
        totalRealBullet.label.text = "{realPoints}";
        totalRealBullet.label.hideOversized = false;
        totalRealBullet.label.fontSize = 10;
        totalRealBullet.label.background.fill = series4.fill;
        totalRealBullet.label.background.fillOpacity = 0.5;
        totalRealBullet.label.padding(2, 2, 2, 2);
        totalRealBullet.label.truncate = false;
        totalRealBullet.maxWidth = 50;

        let obj = this;
        let callback = function(ev){

            let assigneeFullName = ev.target.dataItem.categories.categoryX;
            let valueY = ev.target.dataItem.component.dataFields.valueY;

            chart.series.each(function(series){

                if (series instanceof am4charts.ColumnSeries){

                    series.columns.each(function(column) {

                        if (column === ev.target){

                            // @ts-ignore
                            if (obj.getTemplateViewModel().taskListStatusSelected() == column.dataItem.component.dataFields.valueY && obj.getTemplateViewModel().taskListAssigneeSelected() == column.dataItem.categories.categoryX){

                                valueY = '';
                                assigneeFullName = '';
                                column.setState("default");
                            }else{

                                column.setState("selected");
                            }
                        }else{

                            column.setState("default");
                        }
                    })
                }
            });

            obj.getTemplateViewModel().taskListStatusSelected(valueY);
            obj.getTemplateViewModel().taskListAssigneeSelected(assigneeFullName);

            obj.caller.getIssueData();
            document.getElementById('list-results').scrollIntoView();
        }

        series.columns.template.events.on("hit", callback, obj);
        series2.columns.template.events.on("hit", callback, obj);
        series3.columns.template.events.on("hit", callback, obj);
        series4.columns.template.events.on("hit", callback, obj);

        return series;
    }

    /**
     * Convert a string into a colour. Used to pick a colour procedurally when a chart has a variable number of lines.
     */
    static stringToColour(str){

        let hash = 0;
        for (let i = 0; i < str.length; i++){

            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

        let colour = '#';
        for (let i = 0; i < 3; i++){

            let value = (hash >> (i * 8)) & 0xFF;
            colour += ('00' + value.toString(16)).substr(-2);
        }

        return colour;
    }

    public resetData(){

        this.setHeader([]);
        this.setTableData([]);
        this.setIssuesData([]);

        this.getTemplateViewModel().taskListAssigneeSelected("");
        this.getTemplateViewModel().taskListStatusSelected("");
    }

    public hideExportButton(){

        this.getTemplateViewModel().exportButtonHidden(1);
    }

    public showExportButton(){

        this.getTemplateViewModel().exportButtonHidden(0);
    }

    private getCsvData(obj){

        this.caller.getIssuesDataForCSV();
    }

    private exportCsvData(){

        let fileName = "feature_points_data_" + this.getTemplateViewModel().singleYearSelected() + "_" + this.getTemplateViewModel().singleYearSelected() + ".csv";
        this.csvExporter.exportToCsv(fileName, this.getTemplateViewModel().CSVIssuesData());
    }

    public setCsvExportData(issuesData){

        this.getTemplateViewModel().CSVIssuesData(issuesData);
    }

    public updatePagination(totalCount){

        this.pagination.setNumberItemToPaginate(totalCount);
    }

    public onClickReorder(value, data, event){

        if(typeof data.orderBy === 'undefined'){

            data = this.getTemplateViewModel();
        }

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if(data.orderByAndDirection() === null || data.orderByAndDirection().includes(value)){

            if( data.orderByDirection() == "DESC" ){

                data.orderByDirection("ASC");
            }
            else{

                data.orderByDirection("DESC");
            }
        }
        else{

            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.listReorder();
    }

    public setViewModelFromRequest(params : Array<any>) : void {

        if(typeof params['viewMode'] !== 'undefined'){
            this.getTemplateViewModel().viewModeSelected(params['viewMode']);
        }

        if(typeof params['year'] !== 'undefined'){

            // considered to be a number by typescript because it contains no letter, but we need a string for the filter to work properly.
            this.getTemplateViewModel().singleYearSelected(params['year'].toString());
        }

        if(typeof params['quarter'] !== 'undefined'){
            this.getTemplateViewModel().singleQuarterSelected(params['quarter']);
        }

        if(typeof params['assignees'] !== 'undefined'){
            this.presetFilter.setMultiSelectorPresetFilters(this.filterAssignees, params['assignees']);
        }

        if(typeof params['projects'] !== 'undefined'){
            this.presetFilter.setMultiSelectorPresetFilters(this.filterProjects, params['projects']);
        }

        if(typeof params['departments'] !== 'undefined'){
            this.presetFilter.setMultiSelectorPresetFilters(this.filterDepartments, params['departments']);
        }

        if(typeof params['years'] !== 'undefined'){
            this.presetFilter.setMultiSelectorPresetFilters(this.filterYears, params['years']);
        }

    }
}


// WEBPACK FOOTER //
// ./js/components/templates/featurePoints_template.ts